import { subscribeWS, unsubscribeWS } from 'modules/websocket/WSManager';
import * as services from 'modules/websocket/services/wsFileMetaDataUpdates';
import { onFileMetaDataUpdates } from 'modules/queues/Schedule/actions/onFileMetaDataUpdates';


const WS_FILE_METADATA_UPDATE = 'WS_FILE_METADATA_UPDATE';

export const startObserveFileMetaDataUpdates = (appointmentId) => dispatch =>
  subscribeWS(
    services.WS_FILE_METADATA_UPDATE,
    { appointmentId },
    (...args) => dispatch(onFileMetaDataUpdates(...args)),
    WS_FILE_METADATA_UPDATE,
  );

export const stopObserveFileMetaDataUpdates = () => unsubscribeWS(WS_FILE_METADATA_UPDATE);
